import { Box, IconButton, TableCell, TextField } from '@material-ui/core'
import { ReactComponent as DeleteIcon } from 'icons/trash-icon.svg'
import { Delete, Publish, KeyboardArrowDown } from '@material-ui/icons'

//@ts-ignore
import styled, { useTheme } from 'styled-components'
import { ReactComponent as FilterIcon } from 'icons/filter-icon-search.svg'

export const StyledFilterIcon = styled(FilterIcon)`
  && {
    transform: scale(0.75);
    fill: ${props => props.theme.colors.primary};
  }
`
export const StyledDeleteIcon = styled(DeleteIcon)`
  && {
    fill: ${props => props.theme.colors.error};
    width: 0.8em;
    height: 0.8em;
    margin-right: 1em;
    cursor: pointer;
  }
`

export const StyledHeadTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
  }
`
export const StyledTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
    cursor: pointer;
  }
`

export const StyledTableCellStatus = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
    cursor: pointer;
    text-transform: capitalize;
  }
`

export const Asterisks = styled.span`
  color: ${({theme})=>theme.colors.error};
`

export const SearchInput = styled(TextField)`
  & .MuiInput-input {
    background: no-repeat;
  }
  & .MuiInputBase-root {
    padding: 0em;
    bottom: 0.25em;
  }

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`

export const StyledDateBox = styled(Box)`
  border-radius: 5.125em;
`

export const StyledIconButton = styled(IconButton)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-family: ${props => props.theme.fonts.primary};
    font-weight: bold;
    font-size: 12px;
    line-height: 1em;
    padding: 0;
  }
`
export const StyledLargeDeleteIcon = styled(Delete)`
  && {
    fill: ${props => props.theme.colors.accent1};
  }
`

export const StyledTextField = styled(TextField)`
  && .MuiInput-root {
    border: 2px solid ${props => props.theme.colors.accent};
    background-color: ${props => props.theme.colors.bgPrimary};
  }
  input[type='text']::placeholder {
    text-align: right;
  }
  position: relative;

  && .MuiInputAdornment-root {
    padding-left: 1em;
  }
  && .MuiInputAdornment-root p {
    color: inherit !important;
  }
`

export const DragZoneInput = styled.input`
  display: none;
`
export const DragZoneLabel = styled.label`
  color: ${props => props.theme.colors.primary};
  padding: 0.5rem 2rem;
  border-radius: 0.3rem;
  cursor: pointer;
  line-height: 0.5em;
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
`

export const StyledIcon = styled(Publish)`
  && {
    fill: ${props => props.theme.colors.accent};
  }
`
export const StyledUploadIcon = styled(IconButton)`
  && {
    margin-bottom: -1.5em;
    fill: ${props => props.theme.colors.accent};
    position: unset;
  }
`

export const StyledDropDownArrow = styled(KeyboardArrowDown)`
  color: ${props => props.theme.colors.primary};
`